import MuiRadio, { type RadioProps as MuiRadioProps } from '@mui/material/Radio';

import { IconChecked, IconCheckedDisabled, IconUnchecked, IconUncheckedDisabled } from './icons.tsx';

export const Radio = (props: MuiRadioProps) => (
  <MuiRadio
    checkedIcon={props.disabled ? <IconCheckedDisabled /> : <IconChecked />}
    color="primary"
    icon={props.disabled ? <IconUncheckedDisabled /> : <IconUnchecked />}
    {...props}
  />
);
